import { uniqueId } from 'lodash'
import {CATEGORY_TECHNICAL_SUPPORT} from '@/constants/categoryTechnicalSupport'

const inputs = [
  {
    title: 'Category',
    model: 'category',
    type: 'radio',
    options: CATEGORY_TECHNICAL_SUPPORT,
    listLabel: 'title'
  },
  {
    title: 'Comment',
    model: 'comment',
    type: 'textarea',
    height: '160px'
  },
  {
    title: 'Add file',
    model: 'uploadFile',
    type: 'file',
    version: 'multi-file',
    isHideAddButton: false,
    isHide: false
  }
]

const prefix = 'input_technical-support-form_'
const technicalSupportInputs = inputs.map((item) => {
  item.id = uniqueId(prefix)
  return item
})

export default technicalSupportInputs



// WEBPACK FOOTER //
// ./src/constants/Forms/technicalSupportForm.js